import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Otto } from './otto';

// Reporting locked page for non-admins (reporting-locked brief §1). Otto sets
// the tone; the text carries the meaning, so the page reads correctly with
// images off. No Request-access button and no padlock circle — it's a
// permissions state, not something gone wrong, so nothing here runs warm.
//
// Otto asset rules (§2): front-facing, never scaled above his 132px source —
// here he's at 118px. alt="Otto"; the page doesn't depend on him.
export default function ReportingAccessDenied() {
  const navigate = useNavigate();
  return (
    <div className="flex-1 overflow-auto p-8">
      <div className="max-w-2xl mx-auto bg-white border border-line rounded-xl px-10 py-12 text-center font-['Metropolis']">
        {/* 1 — Otto */}
        <div className="mb-5 flex justify-center">
          <Otto pose="default" size={118} ariaLabel="Otto" />
        </div>

        {/* 2 — Heading with an inline lock icon (19px, grey, aria-hidden — the
            heading text already says "admin only"). Wraps with the heading on
            narrow screens rather than orphaning. */}
        <h2 className="text-xl font-bold text-ink mb-3">
          Oops — this is admin only{' '}
          <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="#51534A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" className="inline-block align-baseline relative top-[2px]">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
        </h2>

        {/* 3 — Otto's line: 16px, darker body colour, no italics or quotes. It
            reads as him speaking because he sits directly above it. */}
        <p className="text-[16px] text-ink mb-3">I'd let you in, but I only work here.</p>

        {/* 4 — Explanation, muted (detail, not message). */}
        <p className="text-sm text-fusion-mid-grey leading-relaxed max-w-md mx-auto mb-5">
          Reporting shows company-wide numbers — spend totals, supplier win rates and team workload — so it's limited to Admins and Super Users.
        </p>

        {/* 5 — Access note. */}
        <p className="text-sm text-fusion-mid-grey mb-7">
          Need access? Have a word with Alchemy and they'll sort it out.
        </p>

        {/* 6 — Back to dashboard, quiet secondary button (never a dead end). */}
        <button
          type="button"
          onClick={() => navigate('/dashboard')}
          className="bg-transparent border border-line text-ink text-[13px] font-bold tracking-[0.15em] uppercase rounded-xl px-5 py-2.5 hover:border-[#DADCCD] transition-colors">
          Back to dashboard
        </button>
      </div>
    </div>
  );
}
